export default __webpack_public_path__ + "static/david-whiteman-d15db096877092e18e5a2e45bdd9a6a6.png";